/**
 * Извлекает средний цвет RGBA из указанного фрагмента HTML изображения.
 *
 * Создает временный canvas, рисует на нем фрагмент изображения по заданным координатам,
 * вычисляет средние значения всех пикселей в области (R, G, B, A) и возвращает строку в формате rgba().
 *
 * @param image Исходное HTMLImageElement
 * @param x Горизонтальная координата левого верхнего угла фрагмента (в пикселях)
 * @param y Вертикальная координата левого верхнего угла фрагмента (в пикселях)
 * @param width Ширина фрагмента (в пикселях)
 * @param height Высота фрагмента (в пикселях)
 * @returns Строка цвета в формате "rgba(r, g, b, a)" или undefined
 */
export function getFragmentColorByImage(
  image: HTMLImageElement,
  x: number,
  y: number,
  width: number,
  height: number,
): string | undefined {
  // Создаём canvas
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    console.warn('Не удалось получить 2D контекст');
    // return 'rgba(0, 0, 0, 1)';
    return;
  }

  // Устанавливаем размеры canvas под фрагмент
  canvas.width = width;
  canvas.height = height;

  // Рисуем фрагмент изображения
  ctx.drawImage(
    image,
    x,
    y,
    width,
    height, // исходный фрагмент
    0,
    0,
    width,
    height, // куда рисовать
  );

  // Получаем пиксельные данные
  const imageData = ctx.getImageData(0, 0, width, height);
  const data = imageData.data;

  // Суммируем все RGBA значения
  let r = 0,
    g = 0,
    b = 0,
    a = 0,
    count = 0;

  for (let i = 0; i < data.length; i += 4) {
    r += data[i]; // R
    g += data[i + 1]; // G
    b += data[i + 2]; // B
    a += data[i + 3]; // A
    count++;
  }

  // Вычисляем средние значения
  const avgR = Math.round(r / count);
  const avgG = Math.round(g / count);
  const avgB = Math.round(b / count);
  const avgA = Math.round(a / count) / 255; // приводим альфу к 0-1

  return `rgba(${avgR}, ${avgG}, ${avgB}, ${avgA})`;
}
